export default "__VITE_ASSET__CEqGnVBW__"